import React from 'react';
import { FeedbackProvider } from 'providers/feedback-provider';
import EquipmentTabs from './equipment-tabs';
import AddEquipmentFormWrapper from './eqipment-form-provider/equipment-form-provider';
import EquipmentTitle from '../equipment-title';
import { TranslationsProvider } from 'providers/translations-provider';
import { drawerKeys } from 'components/my-equipment/translation-keys';
import { PARTS_DIAGRAM_PAGE } from 'constants/analyticsConstants';

const EquipmentForm = ({ isLoggedIn }) => {
  return (
    <TranslationsProvider keys={drawerKeys}>
      <FeedbackProvider>
        <AddEquipmentFormWrapper isLoggedIn={isLoggedIn}>
          <EquipmentTitle />
          <EquipmentTabs formLocation={PARTS_DIAGRAM_PAGE} />
        </AddEquipmentFormWrapper>
      </FeedbackProvider>
    </TranslationsProvider>
  );
};

export default EquipmentForm;
